// import React, { useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min';

// const Carousel = () => {
//   useEffect(() => {
//     const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min');
//     const carouselElement = document.querySelector('#carouselExampleControls');
//     if (carouselElement) {
//       new bootstrap.Carousel(carouselElement, {
//         ride: 'carousel',
//         interval: 3000,  
//       });
//     }
//   }, []);

//   return (
//     <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
//       <div className="carousel-inner">
//         <div className="carousel-item active">
//           <img src="/images/slider/1.jpg" className="d-block w-100" alt="Slide 1" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/2.jpg" className="d-block w-100" alt="Slide 2" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/3.jpg" className="d-block w-100" alt="Slide 3" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/4.jpg" className="d-block w-100" alt="Slide 4" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/5.jpg" className="d-block w-100" alt="Slide 5" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/6.jpg" className="d-block w-100" alt="Slide 6" />
//         </div>
//         <div className="carousel-item">
//           <img src="/images/slider/7.jpg" className="d-block w-100" alt="Slide 6" />
//         </div>
      
        
//       </div>
//       <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
//         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Previous</span>
//       </button>
//       <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
//         <span className="carousel-control-next-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Next</span>
//       </button>
//     </div>
//   );
// };

// export default Carousel;




import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const Carousel = () => {
  return (
    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
      <div className="carousel-inner">

        {/* Slide 1 */}
        <div className="carousel-item active">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/1.jpg" className="d-block w-100 carousel-img" alt="Slide 1" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h1 className="display-5 fw-bold text-white">Welcome to</h1>
            <h2 className="fw-bold text-warning">Morachi Chincholi</h2>
            <p className="text-light fs-5">Anand Krushi Paryatan Kendra</p>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/2.jpg" className="d-block w-100 carousel-img" alt="Slide 2" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Water Park and Water-Related Activities</h2>
            <p className="text-light fs-5">Splash into Fun and Adventure! Dive into Exciting Water Activities for All Age</p>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/3.jpg" className="d-block w-100 carousel-img" alt="Slide 3" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Ride the Adventure: Tractor, Bullock Cart, Horse & More...</h2>
            <p className="text-light fs-5">Explore the Countryside with Unique Riding Experiences</p>
          </div>
        </div>

        {/* Slide 4 */}
        <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/4.jpg" className="d-block w-100 carousel-img" alt="Slide 4" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Unforgettable School Picnics Await!</h2>
            <p className="text-light fs-5">A Perfect Place for Learning, Fun, and Friendship</p>
          </div>
        </div>

        {/* Slide 5 */}
        <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/5.jpg" className="d-block w-100 carousel-img" alt="Slide 5" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Tourist Activities & Food Savor the Taste of Adventure and Tradition</h2>
            <p className="text-light fs-5">Enjoy Delicious Local Cuisine During Your Visit</p>
          </div>
        </div>

        {/* Slide 6 */}
        <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/6.jpg" className="d-block w-100 carousel-img" alt="Slide 6" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Celebrate with Hurda Delights and Mango Magic</h2>
            <p className="text-light fs-5">Join the Festivities of Seasonal Delicacies</p>
          </div>
        </div>


         <div className="carousel-item">
          <div className="carousel-image-wrapper">
            <img src="/images/slider/7.jpg" className="d-block w-100 carousel-img" alt="Slide 6" />
            <div className="carousel-gradient-overlay"></div>
          </div>
          <div className="carousel-caption custom-caption">
            <h2 className="text-white fw-bold">Memorable Events: From Birthdays to Weddings</h2>
            <p className="text-light fs-5">Perfect Venues for Parties, Weddings, and Corporate Events</p>
          </div>
        </div>

      </div>



      {/* Controls */}
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
